/** The longest suspension reason the server takes. */
export const SUSPENSION_REASON_MAX = 2000;

/**
 * What a platform admin can do to an account in this standing: suspend one
 * that can still sign in (or is finishing sign-up), reinstate a suspended
 * one, nothing for a deleted one.
 */
export function suspensionActionFor(status) {
  if (status === "SUSPENDED") return "REINSTATE";
  if (status === "ACTIVE" || status === "PENDING_VERIFICATION") {
    return "SUSPEND";
  }
  return null;
}

/** Why this suspension reason cannot be sent, or null when it can. */
export function suspensionReasonProblem(reason) {
  const text = (reason ?? "").trim();
  if (!text) return "Give the reason. The person sees it in their notice.";
  if (text.length > SUSPENSION_REASON_MAX) {
    return `Keep the reason within ${SUSPENSION_REASON_MAX} characters.`;
  }
  return null;
}
